export * from '@primeuix/themes/lara/skeleton';
export { default } from '@primeuix/themes/lara/skeleton';
